import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/Modal'
import { BtnList as List } from './BtnList'
import { RecruitModal } from './RecruitModal'
import { RenewalModal } from './RenewalModal'


const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
	onModalToggle: (modalID) => dispatch(actions.toggleModal(modalID, true)),
});
const BtnList = connect(mapStateToProps, mapDispatchToProps)(List)


export { BtnList, RecruitModal, RenewalModal }